/**
* Page Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Page Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'page-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth > 630 ) {
        gsap.to( '.image__front', {
          yPercent: -25,
          ease: 'none',
          scrollTrigger: {
            trigger: '.page-banner',
            // start: 'botto',
            // end: "bottom top",
            scrub: 1,
          },
        } );
      } else {
        gsap.to( '.image__front', {
          yPercent: -70,
          ease: 'none',
          scrollTrigger: {
            trigger: '.page-banner',
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
          },
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'page-banner', COMPONENT );
} )( app );
